(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lavly-kokotaulukko"] && !Shopify.designMode) return;
  try {
    class LavlySizeChart extends HTMLElement {
    /** @type {AbortController | null} */
    #controller = null;

    connectedCallback() {
      if (this.#controller) return;
      this.#controller = new AbortController();
      const { signal } = this.#controller;
      const dialog = this.querySelector('dialog');
      if (!dialog) return;
      this.querySelector('[data-open]')?.addEventListener('click', () => dialog.showModal(), { signal });
      this.querySelector('[data-close]')?.addEventListener('click', () => dialog.close(), { signal });
      // Klikkaus taustalle sulkee dialogin.
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      }, { signal });
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
    }
  }

  if (!customElements.get('lavly-size-chart')) {
    customElements.define('lavly-size-chart', LavlySizeChart);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lavly-rotu"] && !Shopify.designMode) return;
  try {
    class LavlyBreedPicker extends HTMLElement {
    /** @type {AbortController | null} */
    #controller = null;
    #sort = 'pop';
    #showAll = false;

    connectedCallback() {
      if (this.#controller) return;
      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.cards = [...this.querySelectorAll('[data-breed]')];
      this.grid = this.querySelector('[data-grid]');
      this.searchInput = this.querySelector('[data-search]');
      this.moreButton = this.querySelector('[data-more]');
      this.customBox = this.querySelector('[data-custom]');
      this.customInput = this.querySelector('[data-custom-input]');
      this.printInput = this.querySelector('[data-print-text]');
      this.fullInput = this.querySelector('[data-full-text]');
      this.initialCount = Number(this.dataset.initialCount) || 8;
      try {
        this.colors = JSON.parse(this.dataset.colors || '{}');
      } catch {
        this.colors = {};
      }

      this.searchInput?.addEventListener('input', () => this.#filter(), { signal });
      this.moreButton?.addEventListener('click', () => {
        this.#showAll = !this.#showAll;
        this.#filter();
      }, { signal });
      for (const button of this.querySelectorAll('[data-sort]')) {
        button.addEventListener('click', () => this.#setSort(button.dataset.sort), { signal });
      }
      this.addEventListener('change', () => this.#update(), { signal });
      this.customInput?.addEventListener('input', () => this.#update(), { signal });

      // Varianttivalitsin on samassa osiossa: luetaan väri ja klubi sen muutoksista.
      const scope = this.closest('.shopify-section') ?? document;
      scope.addEventListener('change', () => requestAnimationFrame(() => this.#syncVariant()), { signal });
      scope.addEventListener('click', () => setTimeout(() => this.#syncVariant(), 50), { signal });

      // Omat valintapainikkeet ohjaavat piilotettua Shopifyn varianttivalitsinta.
      for (const button of this.querySelectorAll('[data-opt-name]')) {
        button.addEventListener('click', () => this.#selectOption(button.dataset.optName, button.dataset.optValue), { signal });
      }
      if (this.querySelector('[data-opt-name]')) scope.classList?.add('lavly-enhanced');

      // Varianttivalitsin ja kokotaulukko tulevat sivulla tämän lohkon jälkeen,
      // joten luetaan ne vasta, kun koko sivu on jäsennetty.
      const ready = () => {
        const sizeChartButton = this.querySelector('[data-open-size-chart]');
        const sizeChart = scope.querySelector('lavly-size-chart dialog');
        if (sizeChartButton) {
          if (sizeChart) {
            sizeChartButton.hidden = false;
            sizeChartButton.addEventListener('click', () => sizeChart.showModal(), { signal });
          } else {
            sizeChartButton.hidden = true;
          }
        }
        this.#filter();
        this.#update();
        this.#syncVariant();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ready, { once: true, signal });
      } else {
        ready();
      }
    }

    #selectOption(name, value) {
      const scope = this.closest('.shopify-section') ?? document;
      for (const input of scope.querySelectorAll('input[data-option-name]')) {
        if (input.dataset.optionName === name && input.value === value) {
          if (!input.checked) input.click();
          setTimeout(() => this.#syncVariant(), 80);
          return;
        }
      }
      for (const select of scope.querySelectorAll('select')) {
        const option = [...select.options].find((o) => o.dataset.optionName === name && o.value === value);
        if (option) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          setTimeout(() => this.#syncVariant(), 80);
          return;
        }
      }
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
    }

    #setSort(sort) {
      this.#sort = sort === 'az' ? 'az' : 'pop';
      for (const button of this.querySelectorAll('[data-sort]')) {
        button.setAttribute('aria-pressed', String(button.dataset.sort === this.#sort));
      }
      const sorted = [...this.cards].sort((a, b) =>
        this.#sort === 'az'
          ? a.dataset.name.localeCompare(b.dataset.name, 'fi')
          : Number(a.dataset.rank) - Number(b.dataset.rank)
      );
      for (const card of sorted) this.grid.append(card);
      this.cards = sorted;
      this.#filter();
    }

    #filter() {
      const query = (this.searchInput?.value ?? '').trim().toLowerCase();
      const matches = this.cards.filter(
        (card) => !query || `${card.dataset.name} ${card.dataset.print}`.toLowerCase().includes(query)
      );
      const limit = query || this.#showAll ? Infinity : this.initialCount;
      let shown = 0;
      for (const card of this.cards) {
        const isMatch = matches.includes(card);
        const isChecked = card.querySelector('input')?.checked;
        const visible = isMatch && (shown < limit || isChecked);
        if (visible) shown++;
        card.hidden = !visible;
      }
      this.querySelector('[data-empty]').hidden = matches.length > 0;
      if (this.moreButton) {
        this.moreButton.hidden = Boolean(query) || matches.length <= this.initialCount;
        this.moreButton.textContent = this.#showAll ? 'Näytä vähemmän' : `Näytä kaikki ${matches.length} rotua`;
      }
    }

    #update() {
      const checked = this.querySelector('input[type="radio"]:checked');
      const isCustom = Boolean(checked?.hasAttribute('data-custom-radio'));
      const card = checked?.closest('[data-breed]');

      if (this.customBox && this.customInput) {
        this.customBox.hidden = !isCustom;
        this.customInput.disabled = !isCustom;
        this.customInput.required = isCustom;
      }

      const customText = (this.customInput?.value ?? '').trim();
      let printText = '';
      let fullText = '';
      let label = '';
      if (isCustom) {
        printText = customText || 'Oma rotu';
        fullText = printText;
        label = customText ? `Oma: ${customText}` : 'Oma rotu';
      } else if (card) {
        printText = card.dataset.print;
        fullText = card.dataset.full || printText;
        label = card.dataset.name;
      }
      if (this.printInput) this.printInput.value = isCustom ? customText : printText;

      const selectedLabel = this.querySelector('[data-selected-label]');
      if (selectedLabel) selectedLabel.textContent = label;

      const headBreed = this.querySelector('[data-head-breed]');
      if (headBreed) headBreed.textContent = printText || 'Rotusi';

      const fullEl = this.querySelector('[data-preview-full]');
      if (fullEl) fullEl.textContent = (fullText || 'Rotusi').toUpperCase();
      if (this.fullInput) this.fullInput.value = isCustom ? customText : fullText;

      const breedEl = this.querySelector('[data-preview-breed]');
      if (breedEl) {
        const text = (printText || 'Rotusi').toUpperCase();
        breedEl.textContent = text;
        const length = Math.max(5, text.length);
        breedEl.style.fontSize = `${Math.min(10.5, 40 / (length * 0.5)).toFixed(2)}cqw`;
      }
    }

    #readOption(name) {
      if (!name) return '';
      const scope = this.closest('.shopify-section') ?? document;
      for (const input of scope.querySelectorAll('input[data-option-name]:checked')) {
        if (input.dataset.optionName === name) return input.value;
      }
      for (const select of scope.querySelectorAll('select')) {
        const option = select.selectedOptions[0];
        if (option?.dataset.optionName === name) return option.value;
      }
      return '';
    }

    #syncVariant() {
      for (const button of this.querySelectorAll('[data-opt-name]')) {
        const current = this.#readOption(button.dataset.optName);
        button.setAttribute('aria-pressed', String(current === button.dataset.optValue));
      }
      for (const label of this.querySelectorAll('[data-opt-label]')) {
        const current = this.#readOption(label.dataset.optLabel);
        if (current) label.textContent = current;
      }
      const headClub = this.querySelector('[data-head-club]');
      const clubValue = this.#readOption(this.dataset.clubOption);
      if (headClub && clubValue) headClub.textContent = clubValue;

      const preview = this.querySelector('.lavly-rotu__preview');
      if (!preview) return;
      const color = this.colors[this.#readOption(this.dataset.colorOption)];
      if (color) preview.style.setProperty('--lavly-print', color);
      const club = this.#readOption(this.dataset.clubOption);
      const clubEl = this.querySelector('[data-preview-club]');
      if (clubEl && club) clubEl.textContent = club.replace(/\s*club\s*$/i, '');
    }
  }

  if (!customElements.get('lavly-breed-picker')) {
    customElements.define('lavly-breed-picker', LavlyBreedPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
